import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IInspection, IInspectionResponse } from '../../inspection/insp.interfaces';

import { DatePipe } from '@angular/common';
import { InspService } from '../../services/inspections/insp.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-data-insp',
  templateUrl: './dialog.component.insp.html',
  styleUrls: ['./dialog.component.insp.scss'],
  providers: [DatePipe, InspService]
})

export class DialogInspection {
  private plate: string;
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editInspeccioData: IInspection;
  
  public userInfo: any = {};
  public filterStates(val: string) {
  }

  constructor(private datePipe: DatePipe, public dialogRef: MatDialogRef<DialogInspection>, @Inject(MAT_DIALOG_DATA) public data: any, public inspService: InspService){ 
   this.editInspeccioData =  data.dades;

   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");

   this.userInfo = data.user;

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editInspeccioData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  afegir(event){
    if(event){
      this.plate = event.value;
    }
  }

  setAny(event, picker) {
    this.data.setFullYear(event.year());
    picker.close();
  }

  ngOnInit(){ }

}
